import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function GetFeedbacks( user) {
  try {
    const apiConfig = await getApiConfig();

    const req = `${apiConfig.BASE_URL}feedback/Feedbacks`;
    const req2 = `${apiConfig.BASE_URL}user/${user}`;

    const responseUser = await axios.get(req2, apiConfig.HEADERS_CONFIG,{

    });


    const feedbacksGet = {     
            responsibleKey: responseUser.data.user.password,
    };
    const responseFeedback = await axios.post(req, feedbacksGet, apiConfig.HEADERS_CONFIG,{

    });
    return responseFeedback.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
